import React from 'react'
import "./Loading.css"
import ReactLoading from "react-loading";

export default function Loading() {
	return <div className='LoadingContainer'><ReactLoading type='spin' /><p>Loading...</p></div>;
}
